module.exports = __webpack_public_path__ + "static/img/bba284ac05b041a8b8b0d1927868d5c9x.0cffd784.jpg";